export default "__VITE_ASSET__Cw$KfueW__"